import "./index.less";
import empty from "@/images/empty.png";
import { useUserInfo, useUserInfoDispath } from "@/model";
import classNames from "classnames";

const Permissions = () => {
  const userInfo = useUserInfo();
  const dispatch = useUserInfoDispath();

  const isLogin = !!(userInfo.loginInfo && userInfo.curUserInfo);

  const goLogin = () => {
    dispatch({ type: "login/open" });
  };

  return (
    <article className="permissions-wrapper max-width">
      <h3>
        抱歉，您当前没有权限访问该页面，请先
        <span className={classNames({ canLogin: !isLogin })} onClick={goLogin}>
          登录
        </span>
        或者点击右上角用户名切换账号再尝试访问
      </h3>
      <img src={empty} alt="" />
    </article>
  );
};

export default Permissions;
